import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Status =
  | 'active' | 'scheduled' | 'ending' | 'ended' | 'archived'
  | 'occupied' | 'vacant'
  | 'invited' | 'not-invited' | 'pending' | 'overdue' | 'paid' | 'draft' | 'reported';

interface StatusBadgeProps {
  status: Status;
  label?: string;
  size?: 'sm' | 'md';
  className?: string;
  'data-testid'?: string;
}

type Tone = 'success' | 'info' | 'warning' | 'danger' | 'secondary';

const statusConfig: Record<Status, { label: string; tone: Tone }> = {
  active:    { label: 'Active',    tone: 'success' },
  occupied:  { label: 'Occupied',  tone: 'success' },
  paid:      { label: 'Paid',      tone: 'success' },
  scheduled: { label: 'Scheduled', tone: 'info' },
  invited:   { label: 'Invited',   tone: 'info' },
  ending:    { label: 'Ending',    tone: 'warning' },
  pending:   { label: 'Pending',   tone: 'warning' },
  overdue:   { label: 'Overdue',   tone: 'warning' },
  ended:     { label: 'Ended',     tone: 'danger' },
  archived:  { label: 'Archived',  tone: 'danger' },
  'not-invited': { label: 'Not Invited', tone: 'secondary' },
  vacant:    { label: 'Vacant',    tone: 'secondary' },
  draft:     { label: 'Draft',     tone: 'secondary' },
  reported:  { label: 'Reported',  tone: 'info' },
};

export function StatusBadge({
  status,
  label,
  size = 'md',
  className,
  'data-testid': testId,
}: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Badge
      variant={config.tone}
      data-testid={testId}
      className={cn(
        'font-medium',
        size === 'sm' && 'text-[10px] px-1.5 py-0',
        size === 'md' && 'text-xs px-2 py-0.5',
        className,
      )}
    >
      {label ?? config.label}
    </Badge>
  );
}
